import {Injectable} from '@angular/core';
import {combineLatest, Observable} from "rxjs";
import {Point} from "@core/models/Point";
import {BackendService} from "@app/core/backendService/backend.service";
import {Survey} from "@app/shared/models/Survey";
import {map} from "rxjs/operators";

import flow from "lodash-es/flow";
import {default as fp_filter} from "lodash/fp/filter";
import {default as fp_map} from "lodash/fp/map";
import {default as fp_sum} from "lodash/fp/sum";
import {RewardService} from "@app/feature/reward/service/reward.service";
import {Purchase} from "@app/feature/reward/models/Reward";


@Injectable({
  providedIn: 'root'
})
export class PointService {
  constructor(
    public backendService: BackendService,
    public rewardService: RewardService,
  ) {
    // @ TODO: implement rest on logout/login
    this.points$ = combineLatest([
      this.backendService.participantSurvey$,
      this.rewardService.purchase$,
    ]).pipe(
      map(([participant_surveys, purchases]:[Survey[], Purchase[]])=>
        this.pointSummary(participant_surveys, purchases)
      )
    )
  }

  public points$: Observable<Point>

  private pointSummary(participant_surveys:Survey[], purchases:Purchase[]){
    let earned = flow(
      fp_filter((s:Survey)=>s.completed && s.points!==null),
      fp_map('points'),
      fp_sum
    )(participant_surveys)
    let used = flow(
      fp_map('reward.points'),
      fp_sum
    )(purchases)
    return new Point({earned, used, balance: earned-used})
  }

  public refresh_points(){
    this.refresh_participant_survey()
    this.refresh_participant_purchases()
  }

  public refresh_participant_survey(){ this.backendService.participantSurveyRefresh$.next()}
  public refresh_participant_purchases(){ this.rewardService.purchaseRefresh$.next() }
}
